export default {
  url: 'https://foxbox.com/',
  // Brand token for composing per-page titles. `title` below is the sitewide
  // <title> fallback and is too long to suffix onto a page name (FOX2-77).
  name: 'Foxbox Digital',
  title: 'Foxbox Digital | Digital Product Agency based in Chicago',
  description: 'Foxbox Digital is an award-winning engineering-focused product development agency based in Chicago.',
  keywords:
    'foxbox,foxbox digital,react native development,react native mobile app development,react native consulting,chicago digital,mobile app development,elixir development, elixir consulting',
  social: {
    linkedIn: 'https://www.linkedin.com/company/foxbox-digital',
    twitter: 'https://twitter.com/foxboxdigital',
    angelList: 'https://angel.co/foxbox-digital',
  },
};
